// assets/eg-profile.js
document.addEventListener('DOMContentLoaded', () => {
  console.log('[eg-profile] boot');

const API = 'https://gear-db-proxy.onrender.com';
const API_BASE = 'https://gear-db-proxy.onrender.com';

  // ——— Helpers ———
  const el = (sel) => document.querySelector(sel);
  const setText = (elm, txt) => { if (elm) elm.textContent = txt ?? ''; };
  const setSrc = (elm, url) => { if (elm && url) elm.src = url; };

function getCurrentCustomer() {
  try {
    if (window.customer && typeof window.customer === "object" && window.customer.id) {
      return window.customer;
    }
    const m = document.querySelector('meta[name="customer"]');
    if (m?.content) return JSON.parse(m.content);
  } catch (err) {
    console.warn("[eg-profile] getCurrentCustomer error", err);
  }
  return null;
}

// ---- Time-ago helper ----
function timeAgo(input) {
  const d = input instanceof Date ? input : new Date(input);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 5) return 'just now';
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d2 = Math.floor(h / 24);
  if (d2 === 1) return 'yesterday';
  if (d2 < 7) return `${d2}d ago`;
  const w = Math.floor(d2 / 7);
  if (w < 5) return `${w}w ago`;
  const mo = Math.floor(d2 / 30);
  if (mo < 12) return `${mo}mo ago`;
  const y = Math.floor(d2 / 365);
  return `${y}y ago`;
}

// ---- Toasts ----
function ensureToastRoot(){
  let root = document.getElementById('egp-toast-root');
  if (!root) {
    root = document.createElement('div');
    root.id = 'egp-toast-root';
    document.body.appendChild(root);
  }
  return root;
}
function toast(msg, type='info', opts={}) {
  const root = ensureToastRoot();
  const t = document.createElement('div');
  t.className = `egp-toast egp-toast--${type}`;
  t.textContent = msg;
  root.appendChild(t);
  requestAnimationFrame(()=> t.classList.add('in'));
  const dur = opts.duration ?? 2200;
  setTimeout(()=> {
    t.classList.remove('in');
    t.addEventListener('transitionend', () => t.remove(), { once: true });
  }, dur);
}

// ---- Avatar fallback as inline SVG data URL ----
function svgAvatarDataURI(name='User'){
  const initials = (name||'U').trim().split(/\s+/).slice(0,2).map(s=>s[0]).join('').toUpperCase();
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'>
    <defs>
      <linearGradient id='g' x1='0' y1='0' x2='1' y2='1'>
        <stop offset='0%' stop-color='#111827'/>
        <stop offset='100%' stop-color='#fb0440'/>
      </linearGradient>
    </defs>
    <rect width='160' height='160' rx='20' fill='url(#g)'/>
    <text x='50%' y='54%' dominant-baseline='middle' text-anchor='middle'
          font-family='system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif'
          font-size='64' fill='#fff' font-weight='700'>${initials}</text>
  </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

// Reuse from anywhere (reviews, comments, etc.)
window.svgAvatarDataURI = window.svgAvatarDataURI || svgAvatarDataURI;

// Optional convenience wrapper if you prefer one call:
window.EG_PROFILE = window.EG_PROFILE || {};
window.EG_PROFILE.avatarFor = function(name, url) {
  // Use uploaded avatar if present; otherwise fallback to initials SVG
  if (url && /^https?:\/\//.test(url)) return url;
  return svgAvatarDataURI(name || 'User');
};

function isNewSince(dateObj, hours=24){
  return (Date.now() - dateObj.getTime()) < hours*3600*1000;
}

// ---- Confetti burst ----
function confettiBurst(atEl) {
  const host = document.createElement('div');
  host.className = 'egp-confetti-host';
  if (atEl) {
    const rect = atEl.getBoundingClientRect();
    host.style.left = (rect.left + rect.width/2) + 'px';
    host.style.top  = (rect.top + window.scrollY + rect.height/2) + 'px';
    host.style.transform = 'translate(-50%, -50%)';
  } else {
    host.style.left = '50%';
    host.style.top = (window.scrollY + 120) + 'px';
    host.style.transform = 'translate(-50%, -50%)';
  }
  document.body.appendChild(host);
  for (let i=0;i<24;i++){
    const p = document.createElement('span');
    p.className = 'egp-confetti';
    p.style.setProperty('--dx', (Math.random()*2-1)*160 + 'px');
    p.style.setProperty('--dy', (Math.random()*-1)*200 - 80 + 'px');
    p.style.setProperty('--rot', (Math.random()*720 - 360) + 'deg');
    p.style.background = ['#fb0440','#f59e0b','#22c55e','#3b82f6','#8b5cf6'][Math.random()*5|0];
    host.appendChild(p);
  }
  setTimeout(()=> host.remove(), 1000);
}

// --- Achievements XP helpers ---
let _xpRulesCache = null;

async function getXpRules() {
  if (_xpRulesCache) return _xpRulesCache;
  try {
    const res = await fetch(`${API}/xp/rules?ts=${Date.now()}`, { cache: "no-store" });
    const data = await res.json();
    _xpRulesCache = data?.ok ? (data.values || {}) : {};
  } catch (err) {
    console.error("[eg-profile] getXpRules error", err);
    _xpRulesCache = {};
  }
  return _xpRulesCache;
}

// Make a snake-ish, lowercase key from a title or key
function slugifyKey(s='') {
  return String(s)
    .toLowerCase()
    .replace(/['’]/g, '')           // drop apostrophes
    .replace(/[^a-z0-9]+/g, '_')    // non-word → _
    .replace(/^_+|_+$/g, '');       // trim _
}

// Best-effort: find the XP for a given achievement item using the rules map.
// Tries multiple candidate keys (a.key, a.code, a.id, slug(title), etc.)
function findAchievementXp(ach, rules) {
  if (!ach || !rules) return 0;

  // Some backends nest achievements, flatten if needed
  const flat = { ...rules, ...(rules.achievements || {}) };

  // Build candidate keys in order of confidence
  const cands = [];
  ['key', 'code', 'id', 'slug', 'name'].forEach(k => {
    if (ach[k]) cands.push(String(ach[k]));
  });

  // Title-derived slugs
  if (ach.title) {
    const t = String(ach.title);
    cands.push(slugifyKey(t));                   // e.g. "First Comment" -> "first_comment"
    cands.push(slugifyKey(t).replace(/^ach_/, ''));
  }

  // Also try prefixed forms to be safe
  const more = [];
  for (const c of cands) {
    const s = slugifyKey(c);
    more.push(s);
    more.push(`achievement_${s}`);
    more.push(`achievements_${s}`);
  }
  const keysToTry = [...cands, ...more];

  for (const k of keysToTry) {
    const v = flat[k];
    if (v && typeof v.xp === 'number') return v.xp;
  }

  return 0;
}

// Tiny pill style for "+XX XP" in achievements list
function ensureAchvXpCSS(){
  if (document.getElementById('egp-achv-xp-css')) return;
  const s = document.createElement('style');
  s.id = 'egp-achv-xp-css';
  s.textContent = `
    .egp-xp-chip {
      display:inline-block;
      margin-left:.5ch;
      padding:.05rem .45rem;
      border-radius:999px;
      border:1px solid #e5e7eb;
      font-size:12px;
      line-height:1.4;
      background:#f9fafb;
      color:#111827;
      white-space:nowrap;
      vertical-align:middle;
    }
    .egp-badge__title { display:flex; align-items:center; gap:.5ch; flex-wrap:wrap; }
  `;
  document.head.appendChild(s);
}

function ensureAchievementsFilter(){
  const grid = document.getElementById('achievementsGrid');
  if (!grid || document.getElementById('achvFilter')) return;

  const bar = document.createElement('div');
  bar.id = 'achvFilter';
  bar.className = 'egp-achv-filter';
  bar.innerHTML = `
    <button class="chip is-active" data-mode="all">All</button>
    <button class="chip" data-mode="unlocked">Unlocked</button>
    <button class="chip" data-mode="locked">Locked</button>
  `;
  grid.insertAdjacentElement('beforebegin', bar);

  bar.addEventListener('click', (e)=>{
    const btn = e.target.closest('button[data-mode]');
    if (!btn) return;
    bar.querySelectorAll('button').forEach(b=>b.classList.toggle('is-active', b===btn));
    const mode = btn.dataset.mode;
    grid.querySelectorAll('.egp-badge').forEach(card=>{
      const locked = card.classList.contains('egp-badge--dim');
      card.style.display =
        mode === 'all' ? '' :
        mode === 'unlocked' ? (locked ? 'none' : '') :
        (locked ? '' : 'none');
    });
  });
}

function renderStars(n){
  const x = Math.max(0, Math.min(5, Math.round(Number(n)||0)));
  let s = '<span class="egp-stars" aria-label="'+x+' out of 5">';
  for (let i=0;i<5;i++){
    s += `<span class="egp-star ${i < x ? 'egp-star--full' : 'egp-star--empty'}">${i < x ? '★' : '☆'}</span>`;
  }
  return s + '</span>';
}

function dateBand(d) {
  const now = new Date();
  const nd  = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const dd  = new Date(d.getFullYear(),   d.getMonth(),   d.getDate());
  const diffDays = Math.round((nd - dd) / 86400000);
  if (diffDays === 0) return 'Today';
  if (diffDays <= 7)  return 'This week';
  return 'Earlier';
}

function animateListSwap(listEl, renderFn) {
  if (!listEl) { renderFn?.(); return; }

  // capture current height
  const startH = listEl.getBoundingClientRect().height;

  // prep styles
  const prev = {
    height: listEl.style.height,
    overflow: listEl.style.overflow,
    transition: listEl.style.transition
  };
  listEl.style.height = startH + 'px';
  listEl.style.overflow = 'hidden';
  listEl.style.transition = 'height 180ms ease';

  // do the render
  renderFn?.();

  // force reflow before reading scrollHeight
  // (helps when DOM changed but layout hasn't committed)
  void listEl.offsetWidth;

  const endH = listEl.scrollHeight;

  // If height didn’t change, skip animation and clean up immediately
  if (Math.abs(endH - startH) < 1) {
    listEl.style.height = prev.height || '';
    listEl.style.overflow = prev.overflow || '';
    listEl.style.transition = prev.transition || '';
    return;
  }

  // animate to new height
  requestAnimationFrame(() => {
    listEl.style.height = endH + 'px';
  });

  const cleanup = () => {
    listEl.style.height = prev.height || '';
    listEl.style.overflow = prev.overflow || '';
    listEl.style.transition = prev.transition || '';
    listEl.removeEventListener('transitionend', cleanup);
  };
  listEl.addEventListener('transitionend', cleanup);

  // Fallback in case transitionend doesn't fire (e.g. display changes)
  setTimeout(cleanup, 240);
}

  function escapeHtml(s){ return String(s ?? '')
  .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

function parseMaybeShopifyDate(s) {
  if (s == null) return null;

  // epoch support
  if (typeof s === 'number') return new Date(s > 1e12 ? s : s * 1000);

  let str = String(s).trim();
  if (!str) return null;

  // "YYYY-MM-DD HH:MM:SS" → treat as UTC
  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(str)) {
    const iso = str.replace(' ', 'T') + 'Z';
    const d = new Date(iso);
    if (!isNaN(d)) return d;
  }

  // If ends with +HHMM / -HHMM, insert missing colon → +HH:MM
  const m = str.match(/([+-]\d{2})(\d{2})$/);
  if (m) str = str.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');

  let d = new Date(str);
  if (!isNaN(d)) return d;

  // Fallback: strict "+0000" → force Z
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}[+-]\d{4}$/.test(str)) {
    d = new Date(str.slice(0, 19) + 'Z');
    if (!isNaN(d)) return d;
  }
  return null;
}

function getActiveCustomerId() {
  const params = new URLSearchParams(location.search);
  const u = params.get('u');
  if (u) return window._egPublicCid || null;   // set in public branch below
  return getCurrentCustomer()?.id || null;
}

// ---- Skeleton loaders ----
function showSkeleton(listEl, rows = 3) {
  if (!listEl) return;
  const item = `
    <li class="egp-li">
      <div class="egp-item">
        <div class="skel skel-thumb"></div>
        <div style="flex:1">
          <div class="skel skel-line lg" style="width:60%"></div>
          <div class="skel skel-line" style="width:90%"></div>
          <div class="skel skel-line" style="width:75%"></div>
        </div>
      </div>
    </li>`;
  listEl.innerHTML = Array.from({ length: rows }).map(() => item).join('');
}

function showActivitySkeletons() {
  const commentsList  = findListByHeading('panel-activity', 'recent comments',  '#panel-activity .egp-list.egp-list--divided');
  const reviewsList   = document.getElementById('recentReviews')   || findListByHeading('panel-activity', 'recent reviews',   '#panel-activity .egp-list:last-of-type');
  const reactionsList = document.getElementById('recentReactions') || findListByHeading('panel-activity', 'recent reactions', '#panel-activity .egp-list:last-of-type');

  if (commentsList)  showSkeleton(commentsList, 3);
  if (reviewsList)   showSkeleton(reviewsList, 3);
  if (reactionsList) showSkeleton(reactionsList, 3);
}

function ensureThumbCSS(){
if (document.getElementById('egp-thumb-css')) return;
const style = document.createElement('style');
style.id = 'egp-thumb-css';
style.textContent = `
    .egp-li { list-style: none; }
    .egp-row { display:flex; gap:10px; text-decoration:none; color:inherit; }
    .egp-thumb { width:40px; height:40px; object-fit:cover; border-radius:4px; background:#f2f2f2; flex:0 0 auto; }
    .egp-list__title { font-weight:600; font-size: 16px; }
    .egp-list__meta { color:#6b7280; font-size:12px; }
    .egp-list__body { margin-top:4px; }
`;
document.head.appendChild(style);
}

function ensureActivityCSS(){
  if (document.getElementById('egp-activity-css')) return;
  const style = document.createElement('style');
  style.id = 'egp-activity-css';
style.textContent = `
  .egp-item { display:flex; gap:10px; align-items:flex-start; padding:10px 0; }
  .egp-item__thumb { width:40px; height:40px; object-fit:cover; border-radius:4px; background:#f2f2f2; flex:0 0 auto; }
  .egp-item__main { flex:1 1 auto; min-width:0; }
  .egp-item__head { display:flex; flex-wrap:wrap; align-items:center; gap:6px; font-weight:600; }
  .egp-item__product { text-decoration:none; color:inherit; }
  .egp-item__product:hover { text-decoration:underline; }

  /* Body wrapper: we animate this height */
  .egp-item__body { margin-top:4px; max-width:100%; overflow-wrap:anywhere; word-break:break-word; }
  .egp-item__body.egp-animating { overflow:hidden; }

  /* The text we clamp */
  .egp-clamp { display:-webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp:2; overflow:hidden; }
  .egp-item__body.is-open .egp-clamp { display:block; -webkit-line-clamp: initial; -webkit-box-orient: initial; overflow:visible; }

  .egp-more { background:none; border:none; padding:0; font:inherit; font-size: 14px; text-decoration: underline; cursor:pointer; margin-bottom:6px; }

  .egp-chip { display:inline-flex; align-items:center; border:1px solid #e5e7eb; border-radius:999px; padding:2px 8px; font-size:14px; color:#374151; background:#fafafa; }
  .egp-chip--ok { border-color:#d1fae5; background:#ecfdf5; color:#065f46; }
  .egp-chip--type { border-color:#e5e7eb; background:#fff; }

  .egp-group { margin:12px 0 6px; font-weight:600; font-size:14px; color:#374151; display:flex; align-items:center; gap:8px; }
  .egp-group::after { content:''; flex:1 1 auto; height:1px; background:#e5e7eb; }

  /* Stars */
  .egp-stars { display:inline-flex; gap:2px; }
  .egp-star--full { color:#f59e0b; }
  .egp-star--empty { color:#d1d5db; }

  /* Card heading icons */
  .egp-card h3 .egp-card-ico { margin-right:6px; opacity:.85; }

  /* NEW: wrap card+pager together to not break your grid */
  .egp-card-wrap { display:flex; flex-direction:column; gap:8px; }
`;
  document.head.appendChild(style);
}
ensureActivityCSS();

function ensureRewardsCSS(){
  if (document.getElementById('egp-rewards-css')) return;
  const s = document.createElement('style');
  s.id = 'egp-rewards-css';
  s.textContent = `
    .egp-reward__codewrap{align-items:center; gap:8px; margin-top:6px;}
    .egp-reward__code{font-weight:600;}
    .egp-rewards-disclaimer{padding:20px;font-size:13px;}
    .egp-bullets{margin:6px 0 0 0; padding-left:18px;}
    .egp-bullets li{margin:4px 0; list-style:disc;}
  `;
  document.head.appendChild(s);
}
ensureRewardsCSS();


function decorateActivityHeadings(){
  const pairs = [
    { text: 'recent comments',  icon: '💬' },
    { text: 'recent reviews',   icon: '★' },
    { text: 'recent reactions', icon: '❤️' }
  ];
  document.querySelectorAll('.egp-card h3').forEach(h3 => {
    const t = (h3.textContent || '').trim().toLowerCase();
    const m = pairs.find(p => t.includes(p.text));
    if (!m || h3.dataset.iconized) return;
    h3.dataset.iconized = '1';
    h3.innerHTML = `<span class="egp-card-ico">${m.icon}</span>${h3.innerHTML}`;
  });
}

function thumbHTML(url){ return url ? `<img class="egp-thumb" src="${escapeHtml(url)}" alt="" loading="lazy">` : ''; }

// Map social keys → icon image URLs
const SOCIAL_ICON_URLS = {
  tw: 'https://cdn.shopify.com/s/files/1/0102/8426/9615/files/Twitter-X.png?v=1705055273',
  ig: 'https://cdn.shopify.com/s/files/1/0102/8426/9615/files/Instagram-logo.png?v=1705055699',
  tt: 'https://cdn.shopify.com/s/files/1/0102/8426/9615/files/twitch.svg?v=1756301216',
  rd: 'https://cdn.shopify.com/s/files/1/0102/8426/9615/files/reddit.svg?v=1756301238',
  yt: 'https://cdn.shopify.com/s/files/1/0102/8426/9615/files/youtube_5fa93a5f-c115-4ddc-abb4-71f541ec8ea4.svg?v=1758373194',
  default: 'YOUR_FALLBACK_ICON_URL'
};

// === Activity pagination config & helpers ===
const ACTIVITY_LIMITS = {
  comments:  { pageSize: 10, max: 50 },
  reviews:   { pageSize: 4,  max: Infinity },
  reactions: { pageSize: 5,  max: 50 }
};

const activityState = {
  commentsItems: [], commentsPage: 1,
  reviewsItems:  [], reviewsPage:  1,
  reactionsItems:[], reactionsPage:1
};

function clamp(n, min, max){ return Math.max(min, Math.min(max, n)); }

function sliceForPage(items, page, pageSize, cap = Infinity) {
  const capped = items.slice(0, Number.isFinite(cap) ? cap : items.length);
  const total  = capped.length;
  const pages  = Math.max(1, Math.ceil(total / pageSize));
  const p      = clamp(page, 1, pages);
  const start  = (p - 1) * pageSize;
  const end    = start + pageSize;
  return { page: p, pages, total, data: capped.slice(start, end) };
}

function ensurePagerAfter(listEl, id) {
  if (!listEl) return null;
  const card = listEl.closest('.egp-card') || listEl;
  if (!card) return null;

  // ensure wrapper around the card
  let wrap = card.parentElement;
  if (!wrap || !wrap.classList.contains('egp-card-wrap')) {
    wrap = document.createElement('div');
    wrap.className = 'egp-card-wrap';
    card.replaceWith(wrap);
    wrap.appendChild(card);
  }

  // ensure pager inside the wrap (after the card)
  let pager = document.getElementById(id);
  if (!pager) {
    pager = document.createElement('div');
    pager.id = id;
    pager.className = 'egp-pager';
    wrap.appendChild(pager);
  } else if (pager.parentElement !== wrap) {
    wrap.appendChild(pager);
  }
  return pager;
}

function renderPager(pagerEl, state, onChange) {
  const { page, pages, total, pageSize } = state;
  if (!pagerEl) return;

  if (!total || pages <= 1) {
    pagerEl.hidden = true;
    pagerEl.innerHTML = '';
    return;
  }

  const from = (page - 1) * pageSize + 1;
  const to   = Math.min(total, page * pageSize);
  pagerEl.hidden = false;
  pagerEl.innerHTML = `
    <div>
      ${page > 1 ? `<button type="button" data-act="prev">Prev</button>` : ``}
      <span class="egp-muted">${from}–${to} of ${total}</span>
      ${page < pages ? `<button type="button" data-act="next">Next</button>` : ``}
    </div>
  `;

  const go = (nextPage) => {
    onChange(nextPage);
    // after DOM re-render, pull the block back into view (great on mobile)
    setTimeout(() => {
      pagerEl.closest('.egp-card-wrap')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  };

  pagerEl.querySelector('[data-act="prev"]')?.addEventListener('click', () => go(page - 1));
  pagerEl.querySelector('[data-act="next"]')?.addEventListener('click', () => go(page + 1));
}

document.addEventListener('click', (e) => {
  const btn = e.target.closest('.egp-more[data-expand]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const body = btn.closest('.egp-item__body');
  if (!body) return;

  const isOpen = body.classList.contains('is-open');
  const duration = 180; // ms

  // measure heights
  const startH = body.offsetHeight;
  let endH;

  if (!isOpen) {
    // opening: apply open class to get natural full height
    body.classList.add('is-open');
    endH = body.scrollHeight;
    // revert to start height to animate from
    body.classList.remove('is-open');
  } else {
    // closing: the collapsed height is the clamped height without is-open
    endH = (() => {
      body.classList.remove('is-open');
      const h = body.offsetHeight;
      body.classList.add('is-open');
      return h;
    })();
  }

  // animate
  body.classList.add('egp-animating');
  body.style.height = startH + 'px';
  body.style.transition = `height ${duration}ms ease`;

  requestAnimationFrame(() => {
    if (!isOpen) body.classList.add('is-open');
    body.style.height = endH + 'px';
  });

  const done = () => {
    body.style.height = '';
    body.style.transition = '';
    body.classList.remove('egp-animating');
    if (isOpen) body.classList.remove('is-open'); // actually close after animation
    btn.textContent = body.classList.contains('is-open') ? 'Show less' : 'Show more';
    btn.setAttribute('aria-expanded', body.classList.contains('is-open') ? 'true' : 'false');
    body.removeEventListener('transitionend', done);
  };
  body.addEventListener('transitionend', done);
});

// Where to open the modal
const GEAR_DB_PATH = '/pages/geardb'; // leave as-is unless your path is different

function gearDbHref(item, kind) {
  // kind = 'comment' | 'review' | 'reaction'

  const handle = item.product_handle || item.handle;

  // Prefer the actual entity id
  let focusType = kind;
  let focusId =
    item.comment_id ||
    item.review_id ||
    item.reaction_id ||
    item.activity_id ||
    item.id ||
    item._id || '';

  // For reactions we want to focus the parent (comment or review), not the reaction icon
  if (kind === 'reaction') {
    const parentCommentId = item.comment_id || item.target_comment_id || item.parent_comment_id;
    const parentReviewId  = item.review_id  || item.target_review_id  || item.parent_review_id;
    if (parentCommentId) { focusType = 'comment'; focusId = String(parentCommentId); }
    else if (parentReviewId) { focusType = 'review'; focusId = String(parentReviewId); }
  }

  const at = item.updated_at || item.created_at || '';

  // Short snippet as best-effort fallback
  const text = (typeof item.body === 'string' && item.body.trim())
    ? item.body
    : (typeof item.text === 'string' && item.text.trim())
      ? item.text
      : (typeof item.comment_body === 'string' && item.comment_body.trim())
        ? item.comment_body
        : '';

  const q = new URLSearchParams();
  if (handle) q.set('handle', handle);
  if (focusId) q.set('focus', `${focusType}:${focusId}`);
  if (at)      q.set('focusAt', at);
  if (text)    q.set('focusText', text.slice(0, 120));

  // we open the modal programmatically on the Gear DB page
  return `${GEAR_DB_PATH}?${q.toString()}`;
}

  // —— DOM targets
  const $name        = el('#displayName');
  const $bio         = el('#bioText');
  const $avatar      = el('#avatarImg');
  const $staffBadge  = el('#staffBadge');

  const $form        = el('#profileSettingsForm');
  const $inpName     = el('#inpDisplayName');
  const $inpBio      = el('#inpBio');
  const $inpAvatar   = el('#inpAvatarUrl');
  const $saveBtn     = el('#btnSaveProfile');
  const $nameHelp    = el('#displayNameHelp');
  const $bioCounter  = el('#bioCounter');
  const $joined = document.getElementById('joinedDateText') || document.getElementById('joinedDateBanner');
  const $locText  = el('#locationText');
  const $inpLoc   = el('#inpLocation');
  const $cover   = el('#profileCover');
  const $inpCover= el('#inpCoverUrl');
  const $socials   = el('#socialLinks');
  const $inpTw     = el('#inpTwitter');
  const $inpIg     = el('#inpInstagram');
  const $inpTt     = el('#inpTwitch');
  const $inpRd     = el('#inpReddit');
  const $inpYt     = el('#inpYoutube');
  const $copyLink = el('#copyProfileLink') || el('#btnCopyProfileLink') || el('.js-copy-profile-url');
  const $level      = document.getElementById('levelBadge');
  const $xpText     = document.getElementById('xpText');
  const $xpLevelLbl = document.getElementById('xpLevelLabel');
  const $xpBarInner = document.getElementById('xpBarInner');
  // ADD ↓
const $pubLevel = document.getElementById('egp-level'); // public header label (Lvl …)
const $pubXp    = document.getElementById('egp-xp');    // public header label (XP …)

// ——— Tabs wiring ———
function wireTabs() {
  const btns = Array.from(document.querySelectorAll('.egp-tab-btn'));
  const panels = {
    activity:     document.getElementById('panel-activity'),
    achievements: document.getElementById('panel-achievements'),
    rewards:      document.getElementById('panel-rewards'),
    notifications: document.getElementById('panel-notifications'),
    settings:     document.getElementById('panel-settings'),
    orders:       document.getElementById('panel-orders'),
    orderDetail:  document.getElementById('panel-order-detail'),
  };
  if (!btns.length) return;

  const sel = document.getElementById('egp-tab-select'); // mobile dropdown

  const activate = (key) => {
    btns.forEach(b => b.classList.toggle('active', b.dataset.tab === key));
    Object.entries(panels).forEach(([k, el]) => el && el.classList.toggle('hidden', k !== key));

    // keep dropdown in sync
    if (sel) sel.value = key;

    // Re-fetch when certain tabs are shown
    if (key === 'achievements') loadAchievements().catch(() => {});
    if (key === 'rewards') {
      loadStats().catch(() => {});
      const cid = getActiveCustomerId();
      if (cid) loadXpHistory(cid, { reset: true });
    }
    if (key === "notifications") loadNotifications(window.customer?.id);
  };

  // --- XP History (paged) ---
  const XP_PAGE_SIZE = 20;
  let _xpItems = [];
  let _xpPage = 1;

  async function loadXpHistory(customerId, { reset = false } = {}) {
    const container = document.getElementById("xpHistory");
    if (!container) return;

    if (reset) { _xpItems = []; _xpPage = 1; }

    if (!_xpItems.length) {
      container.innerHTML = "<p class='egp-muted'>Loading…</p>";
      try {
        const res = await fetch(`${API}/profiles/xp-history?customerId=${customerId}&ts=${Date.now()}`, { cache: "no-store" });
        const data = await res.json();
        if (!data?.ok || !Array.isArray(data.items)) {
          container.innerHTML = "<p class='egp-muted'>Could not load XP history.</p>";
          return;
        }
        _xpItems = data.items;
      } catch (err) {
        console.error("[xpHistory] load error", err);
        container.innerHTML = "<p class='egp-muted'>Could not load XP history.</p>";
        return;
      }
    }
    renderXpHistoryPage(1);
  }

  function renderXpHistoryPage(page = _xpPage) {
    const container = document.getElementById("xpHistory");
    if (!container) return;

    const total = _xpItems.length;
    if (!total) {
      container.innerHTML = "<p class='egp-muted'>No XP history yet.</p>";
      return;
    }

    const pages = Math.ceil(total / XP_PAGE_SIZE);
    _xpPage = Math.max(1, Math.min(page, pages));

    const from = (_xpPage - 1) * XP_PAGE_SIZE;
    const to = Math.min(from + XP_PAGE_SIZE, total);
    const slice = _xpItems.slice(from, to);

    let html = `<h3>XP History</h3><ul class="egp-xp-history card">`;
    for (const ev of slice) {
      const sign = ev.amount > 0 ? "+" : "";
      const when = new Date(ev.created_at).toLocaleDateString();
      html += `
        <li>
          <div>
            <span class="xp-amount">${sign}${ev.amount} XP</span>
            <span class="xp-label">${ev.label ?? ev.type ?? ""}</span>
          </div>
          <span class="xp-date">${when}</span>
        </li>`;
    }
    html += `</ul>`;

    if (pages > 1) {
      const showing = `${from + 1}–${to} of ${total}`;
      const showPrev = _xpPage > 1;
      const showNext = _xpPage < pages;
      html += `
        <div id="xpHistoryPager" class="egp-pager">
          ${showPrev ? `<button type="button" data-act="prev">Prev</button>` : ``}
          <span class="egp-muted">${showing}</span>
          ${showNext ? `<button type="button" data-act="next">Next</button>` : ``}
        </div>`;
    }

    container.innerHTML = html;
  }

  // delegated pager listener
  document.addEventListener("click", (e) => {
    const pager = e.target.closest("#xpHistoryPager");
    if (!pager) return;
    const btn = e.target.closest("button[data-act]");
    if (!btn) return;
    if (btn.dataset.act === "prev") renderXpHistoryPage(_xpPage - 1);
    if (btn.dataset.act === "next") renderXpHistoryPage(_xpPage + 1);
  });

  // button clicks
  btns.forEach(btn => btn.addEventListener('click', () => {
    const key = btn.dataset.tab;
    activate(key);

    const url = new URL(window.location);
    url.searchParams.set("tab", key);
    if (key !== "orders" && key !== "orderDetail") {
      url.searchParams.delete("order");
    }
    history.replaceState(null, "", url);
  }));

  // dropdown change
  if (sel) {
    sel.addEventListener('change', () => {
      const val = sel.value;
      if (val === 'logout') {
        location.href = "{{ routes.account_logout_url }}";
      } else {
        activate(val);
        const url = new URL(window.location);
        url.searchParams.set("tab", val);
        if (val !== "orders" && val !== "orderDetail") {
          url.searchParams.delete("order");
        }
        history.replaceState(null, "", url);
      }
    });
  }

  // initial tab
  const params = new URLSearchParams(window.location.search);
  const forcedTab = params.get('tab');
  const initial =
    forcedTab ||
    btns.find(b => b.classList.contains('active'))?.dataset.tab ||
    btns[0].dataset.tab;
  activate(initial);
}

  wireTabs();

// ——— Orders: in-tab "View Order" loader ———
(function wireAccountOrderViewer(){
  const ordersPanel = document.getElementById('panel-orders');
  const detailPanel = document.getElementById('panel-order-detail');

  if (!ordersPanel || !detailPanel) return;

  // Back button (from detail → orders list)
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.js-back-to-orders')) return;
    e.preventDefault();

    detailPanel.classList.add('hidden');
    ordersPanel.classList.remove('hidden');

    // reset tab state
    document.querySelectorAll('.egp-tab-btn').forEach(b => {
      b.classList.toggle('active', b.dataset.tab === 'orders');
    });

    const url = new URL(location.href);
    url.searchParams.set('tab','orders');
    url.searchParams.delete('order');
    history.replaceState(null,'',url);
  });

  // View Order → fetch and show account_order section
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.js-view-order');
    if (!btn) return;
    e.preventDefault();

    const orderUrl = btn.dataset.orderUrl;
    const orderId  = btn.dataset.orderId;
    if (!orderUrl) return;

    detailPanel.innerHTML = `
      <div class="egp-card"><p class="egp-muted">Loading order…</p></div>
    `;

    try {
      const res  = await fetch(orderUrl, { credentials: 'same-origin' });
      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      const inner =
        doc.querySelector('[data-section-type="account-order"]') ||
        doc.querySelector('[data-section-id*="account-order"]') ||
        doc.querySelector('main');

      if (!inner) {
        detailPanel.innerHTML = `
          <div class="egp-card"><p class="egp-muted">Could not load order details.</p></div>`;
        return;
      }

      // inject detail + footer button
      detailPanel.innerHTML = '';
      detailPanel.appendChild(inner.cloneNode(true));

      const footer = document.createElement('div');
      footer.className = 'egp-card';
      footer.style.marginTop = '12px';
      footer.style.textAlign = 'right';
      footer.innerHTML = `<button type="button" class="js-back-to-orders egp-btn egp-btn--small">Back to Orders</button>`;
      detailPanel.appendChild(footer);

      // show detail panel, hide orders list
      ordersPanel.classList.add('hidden');
      detailPanel.classList.remove('hidden');

      // clear tab highlights, treat detail as its own tab
      document.querySelectorAll('.egp-tab-btn').forEach(b => b.classList.remove('active'));

      // update URL params
      const url = new URL(location.href);
      url.searchParams.set('tab','orderDetail');
      if (orderId) url.searchParams.set('order',orderId);
      history.replaceState(null,'',url);

    } catch (err) {
      console.error('[account] order fetch failed', err);
      detailPanel.innerHTML = `
        <div class="egp-card"><p class="egp-muted">Failed to load order.</p></div>`;
    }
  });

  // Auto-open from query (?order=…)
  (function autoOpenOrderFromQuery(){
    const p = new URLSearchParams(location.search);
    const order = p.get('order');
    if (!order) return;
    document.querySelector(`.js-view-order[data-order-id="${order}"]`)?.click();
  })();
})();

// === Rewards Tab ===
const rewardMilestones = [
  { level: 1,   title: "Rookie",       reward: "Welcome to the game",                                                         code: "" },
  { level: 3,   title: "Explorer",     reward: "FREE delivery on your next order",                                            code: "EGXP-LVL3-EXPL" },
  { level: 5,   title: "Apprentice",   reward: "Buy 1 get 1 FREE (Skates & Grips)",                                           code: "EGXP-LVL5-APPR" },
  { level: 8,   title: "Seeker",       reward: "£10 off next order",                                                          code: "EGXP-LVL8-SEEK" },
  { level: 10,  title: "Adventurer",   reward: "10% off next order",                                                          code: "EGXP-LVL10-ADVE" },
  { level: 15,  title: "Trailblazer",  reward: "£20 off next order",                                                          code: "EGXP-LVL15-TRAI" },
  { level: 20,  title: "Guardian",     reward: "20% off next order",                                                          code: "EGXP-LVL20-GUAR" },
  { level: 25,  title: "Champion",     reward: "Buy 1 get 1 half price (Mousepad)",                                           code: "EGXP-LVL25-CHAM" },
  { level: 30,  title: "Hero",         reward: "£25 off next order",                                                          code: "EGXP-LVL30-HERO" },
  { level: 40,  title: "Veteran",      reward: "Access to EG's VIP-only Discord channel (early access, exclusives & gifts)",  code: "" },
  { level: 50,  title: "Elite",        reward: "£50 off next order",                                                          code: "EGXP-LVL50-ELIT" },
  { level: 75,  title: "Master",       reward: "5-Year access to VIP 10% discounts",                                          code: "" },
  { level: 100, title: "Legend",       reward: "Buy 1 get 1 FREE (Mousepad)",                                                 code: "EGXP-LVL100-LEGE" },
  { level: 150, title: "Mythic",       reward: "5-Year access to VIP 20% discounts",                                          code: "" },
  { level: 200, title: "Immortal",     reward: "5-Year of FREE Delivery + 1 of 5 max 'Community Hero' Discord roles",         code: "" },
];

// Exponential curve, calibrated so L200 ≈ 65,722 XP
function xpForLevel(n) {
  const A = 38705;   // tuned to keep L200 ≈ 65,722 with the shift
  const B = 1.005;
  return Math.round(A * (Math.pow(B, n - 1) - 1)); // ← note n-1
}

async function renderXpRules() {
  const rulesEl = document.getElementById("xpRules");
  if (!rulesEl) return;

  try {
    const res = await fetch(`${API}/xp/rules?ts=${Date.now()}`, { cache: "no-store" });
    const data = await res.json();
    if (!data?.ok || !data.values) {
      rulesEl.innerHTML = "<p class='egp-muted'>Could not load XP rules.</p>";
      return;
    }

    // Group by XP value
    const grouped = {};
    for (const [key, val] of Object.entries(data.values)) {
      if (!val || typeof val.xp !== "number") continue;
      if (val.xp <= 0) continue;
      const xp = val.xp;
      if (!grouped[xp]) grouped[xp] = [];
      grouped[xp].push(val.label || key);
    }

    // Build rules HTML
    let rulesHtml = "";
    for (const xp of Object.keys(grouped).sort((a, b) => Number(a) - Number(b))) {
      rulesHtml += `<div>
        <h4>${xp > 0 ? `+${xp} XP` : "Bonus XP"}</h4>
        <ul class="egp-xp-rules">
          ${grouped[xp].map(lbl => `<li>${lbl}</li>`).join("")}
        </ul>
      </div>`;
    }

    // Wrap in collapsible container
    rulesEl.innerHTML = `
      <div class="xp-rules-wrapper">
        <h3 class="xp-rules-header">
          <button class="xp-rules-toggle" aria-expanded="false">
            How XP is Earned <span class="caret">▼</span>
          </button>
        </h3>
        <div class="xp-rules-body collapsed">
          ${rulesHtml}
        </div>
      </div>
    `;

    // Toggle logic
    const toggleBtn = rulesEl.querySelector(".xp-rules-toggle");
    const body = rulesEl.querySelector(".xp-rules-body");
    toggleBtn.addEventListener("click", () => {
      const expanded = toggleBtn.getAttribute("aria-expanded") === "true";
      toggleBtn.setAttribute("aria-expanded", String(!expanded));
      body.classList.toggle("collapsed", expanded);
      toggleBtn.querySelector(".caret").textContent = expanded ? "▼" : "▲";
    });

  } catch (err) {
    console.error("[eg-profile] xp rules error", err);
    rulesEl.innerHTML = "<p class='egp-muted'>Could not load XP rules.</p>";
  }
}

function renderRewards(currentLevel, totalXp) {
  const listEl = document.getElementById("rewardsList");
  const progressEl = document.getElementById("rewardsProgress");
  if (!listEl || !progressEl) return;

  // Find next milestone
  const next = rewardMilestones.find(m => m.level > currentLevel);
  if (next) {
    const nextXp = xpForLevel(next.level);
    const remaining = Math.max(0, nextXp - totalXp);
    progressEl.innerHTML = `
      <p>You are Level ${currentLevel} with ${totalXp} XP. Only <strong>${remaining}</strong> XP away from <strong>Level ${next.level}: ${next.title}</strong> 🎉</p>
    `;
  } else {
    progressEl.innerHTML = `<p>You’ve unlocked all rewards so far. 🏆</p>`;
  }

  // Build header row + reward rows (with reveal button)
  const html = `
    <div class="egp-reward-header">
      <div>Level</div>
      <div>Rank</div>
      <div>XP Required</div>
      <div>Reward</div>
      <div>Status</div>
    </div>
    ${rewardMilestones.map(m => {
      const unlocked = currentLevel >= m.level;
      const canReveal = unlocked && m.code && String(m.code).trim().length > 0;
      const code = canReveal ? String(m.code).trim() : "";
      return `
        <div class="egp-reward-row ${unlocked ? 'reward-unlocked' : 'reward-locked'}" data-level="${m.level}">
          <div>Lvl ${m.level}</div>
          <div>${m.title}</div>
          <div>${xpForLevel(m.level)} XP</div>
          <div class="egp-reward__desc">
            ${m.reward}
            ${canReveal ? `
              <span class="egp-reward__sep"> · </span>
              <button type="button"
                      class="egp-reward__reveal js-reveal-code"
                      aria-expanded="false">Reveal code</button>

              <!-- Grouped (hidden by default via CSS) -->
              <div class="egp-reward__codewrap">
                <span class="egp-reward__code">${code}</span>
                <button type="button"
                        class="egp-reward__copy js-copy-code"
                        data-code="${code}">Copy</button>
              </div>
            ` : ``}
          </div>
          <div>${unlocked ? "✅" : "🔒"}</div>
        </div>
      `;
    }).join("")}
  `;

listEl.innerHTML = html;

// Force all code groups hidden at first paint (inline beats theme CSS)
listEl.querySelectorAll('.egp-reward__codewrap').forEach(w => {
  w.style.display = 'none';
});

// Disclaimer (bulleted)
const disclaimer = document.createElement('div');
disclaimer.className = 'egp-rewards-disclaimer egp-muted';
disclaimer.innerHTML = `
  <p style="margin:0 0 6px 0;"><strong>Important:</strong></p>
  <ul class="egp-bullets">
    <li>Rewards and codes are non-transferable and can only be redeemed by the unlocking account.</li>
    <li>Some items/collections may be excluded from discounts (limited drops, bundles, clearance, etc.)</li>
    <li>Codes can’t be combined with other promotions.</li>
    <li>Some perks (VIP access & roles) may be activated within 72 hours.</li>
    <li>Suspected abuse (duplicate accounts, spam activity, etc.) may void rewards and XP.</li>
    <li>Rewards and thresholds are subject to change as the system evolves to include new features.</li>
  </ul>
`;
listEl.appendChild(disclaimer);
}

// Reveal/Copy handlers — inline display toggle (wins over theme CSS)
try {
  document.removeEventListener('click', window.__egpRevealHandler__, true);
  document.removeEventListener('click', window.__egpRevealHandler__);
} catch {}

window.__egpRevealHandler__ = function(e){
  const btn = e.target.closest('.js-reveal-code, .js-copy-code');
  if (!btn) return;

  // Reveal/Hide
  if (btn.classList.contains('js-reveal-code')) {
    e.preventDefault();
    e.stopPropagation();

    const desc = btn.closest('.egp-reward__desc');
    const wrap = desc && desc.querySelector('.egp-reward__codewrap');
    if (!wrap) {
      console.warn('[egp] reveal clicked but no .egp-reward__codewrap found');
      return;
    }

    // Inline toggle only
    const isOpen = wrap.style.display && wrap.style.display !== 'none';
    wrap.style.display = isOpen ? 'none' : 'flex';
    btn.setAttribute('aria-expanded', String(!isOpen));
    btn.textContent = isOpen ? 'Reveal code' : 'Hide code';
    return;
  }

  // Copy
  if (btn.classList.contains('js-copy-code')) {
    e.preventDefault();
    const code = btn.dataset.code
              || btn.previousElementSibling?.textContent?.trim()
              || '';
    if (code) {
      (navigator.clipboard?.writeText(code) || Promise.reject()).catch(()=>{});
      const prev = btn.textContent;
      btn.textContent = 'Copied!';
      setTimeout(()=> btn.textContent = prev || 'Copy', 1200);
    }
  }
};
document.addEventListener('click', window.__egpRevealHandler__, true);

  // ——— “Edit Profile” shortcut → Settings tab ———
  (function wireEditShortcut(){
    const editBtn = document.getElementById('editProfileBtn');
    if (!editBtn) return;
    editBtn.addEventListener('click', () => {
      const btn = document.querySelector('.egp-tab-btn[data-tab="settings"]');
      btn?.click();
      btn?.closest('.egp-tabs')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  })();

  // ——— Live display-name availability ———
  let nameOk = true;
  let nameTimer;

  function setHelp(msg, tone) {
    if (!$nameHelp) return;
    $nameHelp.textContent = msg;
    $nameHelp.style.color =
      tone === 'ok'   ? '#0a7a0a' :
      tone === 'warn' ? '#b36b00' :
      tone === 'error'? '#b00020' : '#6b7280';
  }

async function checkNameAvailability(name) {
  if (!name) {
    nameOk = false;
    setHelp('Display name is required.', 'warn');
    return;
  }

  const valid = /^[a-z0-9._-]+$/i.test(name);
  if (!valid) {
    nameOk = false;
    setHelp('Only letters, numbers, ., _, - allowed.', 'error');
    if ($inpName) $inpName.style.outline = '1px solid #b00020';
    return;
  }

  setHelp('Checking availability…');

  try {
    const r = await fetch(`${API}/profiles/display-name/available?name=${encodeURIComponent(name)}`);
    const data = await r.json();
    if (data?.available) {
      nameOk = true;
      setHelp('✓ Available', 'ok');
      if ($inpName) $inpName.style.outline = '1px solid #16a34a';
    } else {
      nameOk = false;
      setHelp('✗ Name is taken', 'error');
      if ($inpName) $inpName.style.outline = '1px solid #b00020';
    }
  } catch {
    nameOk = false;
    setHelp('Could not check right now', 'error');
  }
}

  if ($inpName) {
    $inpName.addEventListener('input', () => {
      clearTimeout(nameTimer);
      const v = ($inpName.value || '').trim();
      nameTimer = setTimeout(() => checkNameAvailability(v), 300);
    });
  }

// ——— Save handler (always wired) ———
async function saveProfile() {
  const originalDisplayName = $inpName?.getAttribute('data-original')?.trim();
  console.log('[eg-profile] save clicked');

  if (!$form) { console.warn('[eg-profile] form not found'); return; }

  const current = getCurrentCustomer();
  if (!current?.id) {
    alert('You need to be logged in to update your profile.');
    console.warn('[eg-profile] no customer id found');
    return;
  }
  const display_name = ($inpName?.value || '').trim();
  const bio = ($inpBio?.value || '').trim().slice(0, 300);
  const avatar_url = ($inpAvatar?.value || '').trim();

  const payload = {
    customerId: current.id,
    display_name,
    bio,
    avatar_url: avatar_url.startsWith('http') ? avatar_url : '',
    location: ($inpLoc?.value || '').trim(),
    cover_image_url: ($inpCover?.value || '').trim().startsWith('http') ? $inpCover.value.trim() : '',
    socials: {
      twitter:   ($inpTw?.value || '').trim(),
      instagram: ($inpIg?.value || '').trim(),
      twitch:    ($inpTt?.value || '').trim(),
      reddit:    ($inpRd?.value || '').trim(),
      youtube:   ($inpYt?.value || '').trim(),
    },
  };

  const nameWasChanged = payload.display_name.toLowerCase() !== originalDisplayName?.toLowerCase();
  if (nameWasChanged) {
    await checkNameAvailability(payload.display_name);
    if (!payload.display_name || !nameOk) {
      alert('Please choose a valid, available display name.');
      return;
    }
  }

  if ($inpAvatar && $inpAvatar.value.trim()) {
    const trimmed = $inpAvatar.value.trim();
    if (!/^https?:\/\//.test(trimmed)) {
      alert('Avatar URL must start with http or https.');
      return;
    }
  }

  try {
    if ($saveBtn) { 
      $saveBtn.disabled = true; 
      $saveBtn.textContent = 'Saving…'; 
    }

    const url = `${API}/profiles/me`;
    console.log('[eg-profile] PUT', url, payload);

    const res = await fetch(url, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });

    // Read raw body first
    const raw = await res.text();

    if (!res.ok) {
      console.error('[eg-profile] PUT failed', res.status, raw);
      alert(`Save failed (${res.status}): ${raw || 'No error body'}`);
      return;
    }

    let data = {};
    try { data = raw ? JSON.parse(raw) : {}; } catch (_) {}
    console.log('[eg-profile] PUT ok', data);

    await loadProfile();
    toast('Profile updated', 'success');

    // ✅ Success state
    if ($saveBtn) {
      $saveBtn.textContent = 'Saved ✓';
      $saveBtn.style.backgroundColor = '#16a34a'; // green (Tailwind green-600)
      $saveBtn.style.borderColor = '#16a34a';
      $saveBtn.style.color = '#fff';

      setTimeout(() => {
        $saveBtn.disabled = false;
        $saveBtn.textContent = 'Save Changes';
        $saveBtn.style.backgroundColor = ''; // reset to default
        $saveBtn.style.borderColor = '';
        $saveBtn.style.color = '';
      }, 2000);
    }

  } catch (e) {
    console.error('[eg-profile] save error', e);
    alert('Could not save profile: ' + (e?.message || e));
    if ($saveBtn) { 
      $saveBtn.disabled = false; 
      $saveBtn.textContent = 'Save Changes'; 
    }
  }
}

  if ($saveBtn) {
    $saveBtn.addEventListener('click', saveProfile);
    console.log('[eg-profile] save handler wired');
  } else {
    console.warn('[eg-profile] #btnSaveProfile not found');
  }

// ——— Public profile link: force /pages/profile ———
(function wirePublicProfileLink() {
  const $link =
    el('#publicProfileLink') ||
    el('#copyProfileLink') ||
    el('#btnCopyProfileLink') ||
    el('.js-copy-profile-url');

  if (!$link) return;

  // Prefer explicit override via data-public-base; default to /pages/profile
  const PUBLIC_BASE = $link.dataset.publicBase || '/pages/profile';

  const getDisplayName = () => {
    const v = ($inpName?.value || '').trim();
    if (v) return v;
    const t = ($name?.textContent || '').trim();
    return t && t.toLowerCase() !== 'anonymous' ? t : null;
  };

  const computePublicUrl = () => {
    const name = getDisplayName();
    if (!name) return null;
    const url = new URL(PUBLIC_BASE, location.origin);
    url.searchParams.set('u', name);
    return url.toString();
  };

  const ensureHref = () => {
    const url = computePublicUrl();
    if (url) {
      $link.setAttribute('href', url);
      $link.setAttribute('target', '_blank');
      $link.setAttribute('rel', 'noopener');
    }
  };

  ensureHref();
  $inpName?.addEventListener('input', ensureHref);

  $link.addEventListener('click', (e) => {
    e.preventDefault();
    const url = computePublicUrl();
    if (!url) return; // optionally toast('Add a display name first', 'info');
    window.open(url, '_blank', 'noopener');
  });
})();

function hydrateProfile(p, stats = {}, isOwn = false) {
  if (!p) {
    console.warn("[eg-profile] hydrateProfile called with no profile");
    return;
  }

  // Basics
  setText($name, p.display_name || "Anonymous");
  setText($bio, p.bio || "");
  const viewer = (typeof getCurrentCustomer === 'function' ? getCurrentCustomer() : null) || {};
  const nameForInitials =
    (p.display_name && p.display_name.trim())
      ? p.display_name
      : [p.first_name ?? viewer.first_name, p.last_name ?? viewer.last_name]
          .filter(Boolean).join(' ') || 'User';

  const desiredAvatar =
    (p.avatar_url && /^https?:\/\//.test(p.avatar_url))
      ? p.avatar_url
      : svgAvatarDataURI(nameForInitials);

  setSrc($avatar, desiredAvatar);
  if ($avatar) {
    $avatar.onerror = () => { $avatar.onerror = null; setSrc($avatar, svgAvatarDataURI(nameForInitials)); };
    $avatar.alt = `${nameForInitials} avatar`;
  }
  if ($cover) $cover.style.backgroundImage = p.cover_image_url ? `url("${p.cover_image_url}")` : "";
  if ($locText) $locText.textContent = p.location || "";

  // ✅ Staff badge toggle (we lost this earlier)
  if ($staffBadge) $staffBadge.classList.toggle('hidden', !p.is_staff);

  // Joined date (profile or stats; fallback to logged-in customer for account page)
  if ($joined) {
    const raw =
      stats?.customer_created_at ||
      p.customer_created_at ||
      p.shopify_customer_created_at ||
      p.joined_at ||
      p.created_at || p.createdAt;

    let jd = parseMaybeShopifyDate(raw);

    if (!jd && isOwn) {
      const me = getCurrentCustomer?.();
      jd = parseMaybeShopifyDate(me?.created_at || me?.createdAt);
    }

    $joined.textContent = jd ? `Joined ${jd.toLocaleDateString()}` : '';
  }

  // Level beside the name — prefer stats.level, fallback to profile.level
  const levelVal = (typeof stats.level === 'number') ? stats.level : p.level;
  if ($level && levelVal != null) $level.textContent = `Lvl ${levelVal}`;

  // Header minis (optional)
  if ($pubLevel) $pubLevel.textContent = levelVal != null ? `Lvl ${levelVal}` : "";
  if ($pubXp)    $pubXp.textContent    = (typeof (stats.total_xp ?? p.total_xp) === 'number')
    ? `XP ${(stats.total_xp ?? p.total_xp)}`
    : "";

  // Stat tiles (only when we actually have values)
  if (stats && Object.keys(stats).length) {
    const set = (id, v) => { const n = document.getElementById(id); if (n) n.textContent = v ?? 0; };
    set("statComments",       stats.comments);
    set("statReviews",        stats.reviews);
    set("statLikesGiven",     stats.likes_given);
    set("statLikesReceived",  stats.likes_received);
    set("statAchievements",   stats.achievements_unlocked);
    set("statDailyStreak",    stats.daily_streak);
    set("statWeeklyStreak",   stats.weekly_streak);
  }

  // XP bar (robust): prefer stats.*, otherwise derive from total_xp (profile or stats)
  if ($xpText && $xpLevelLbl && $xpBarInner) {
    const srcLevel     = (typeof stats.level === 'number') ? stats.level : (p.level ?? 1);
    let inLvl          = Number(stats.level_xp ?? NaN);
    let next           = Number(stats.next_level_xp ?? NaN);
    let pct            = Number(stats.progress_pct ?? NaN);
    const totalXpKnown = (typeof stats.total_xp === 'number') ? stats.total_xp :
                         (typeof p.total_xp === 'number')     ? p.total_xp     : null;

    if (isNaN(inLvl) || isNaN(next) || isNaN(pct)) {
      if (totalXpKnown != null) {
        const prevCap = xpForLevel(srcLevel);
        const nextCap = xpForLevel(srcLevel + 1);
        inLvl = Math.max(0, totalXpKnown - prevCap);
        next  = Math.max(1, nextCap - prevCap);
        pct   = Math.max(0, Math.min(100, (inLvl / next) * 100));
      } else {
        // final fallback: show 0%
        inLvl = 0; next = 100; pct = 0;
      }
    }

    $xpText.textContent     = `${inLvl} / ${next} XP`;
    $xpLevelLbl.textContent = `Level ${srcLevel + 1}`;
    $xpBarInner.style.width = `${pct}%`;
  }

// Socials — support flattened, nested, and *_url keys; unhide when populated
if ($socials) {
  const s = (p.socials && typeof p.socials === 'object') ? p.socials : {};
  const pick = (...keys) => keys.map(k => p[k] ?? s[k]).find(Boolean);

  const ensureUrl = (v, base) => {
    if (!v) return '';
    if (/^https?:\/\//i.test(v)) return v;
    if (v.startsWith('@')) v = v.slice(1);
    return base ? base + v : v;
  };

  const tw = ensureUrl(pick('social_twitter','twitter','x','twitter_url'), 'https://twitter.com/');
  const ig = ensureUrl(pick('social_instagram','instagram','instagram_url'), 'https://instagram.com/');
  const tt = ensureUrl(pick('social_twitch','twitch','twitch_url'), 'https://twitch.tv/');
  const rd = ensureUrl(pick('social_reddit','reddit','reddit_url'), 'https://reddit.com/u/');
  const yt = ensureUrl(pick('social_youtube','youtube','youtube_url'), 'https://youtube.com/');

  const items = [
    tw && { k:'tw', url:tw, label:'Twitter/X' },
    ig && { k:'ig', url:ig, label:'Instagram' },
    tt && { k:'tt', url:tt, label:'Twitch' },
    rd && { k:'rd', url:rd, label:'Reddit' },
    yt && { k:'yt', url:yt, label:'YouTube' },
  ].filter(Boolean);

  $socials.innerHTML = items.length
    ? items.map(i => `
        <a class="egp-social" href="${i.url}" target="_blank" rel="noopener" title="${i.label}">
          <img class="egp-social__img"
              src="${SOCIAL_ICON_URLS[i.k] || SOCIAL_ICON_URLS.default}"
              alt="${i.label}" width="18" height="18" loading="lazy" decoding="async">
        </a>
      `).join('')
    : '';
  $socials.hidden = items.length === 0;
}

  // Settings (own profile only)
  if (isOwn) {
    if ($inpName)   { 
      $inpName.value = p.display_name || ""; 
      $inpName.setAttribute("data-original", p.display_name || ""); 
    }
    if ($inpBio) {
      $inpBio.value = p.bio || "";

      // live counter (single binding)
      const updateCounter = () => {
        const len = ($inpBio.value || "").length;
        if ($bioCounter) {
          $bioCounter.textContent = `${len} / 300`;
          $bioCounter.style.color = len > 300 ? '#b00020' : '#6b7280';
        }
      };

      // avoid double-binding across re-hydrates
      if ($inpBio._egpCounterFn) {
        $inpBio.removeEventListener('input', $inpBio._egpCounterFn);
      }
      $inpBio._egpCounterFn = updateCounter;

      $inpBio.addEventListener('input', updateCounter);
      updateCounter(); // run once now
    }
    if ($inpAvatar) $inpAvatar.value = p.avatar_url || "";
    if ($inpLoc)    $inpLoc.value    = p.location || "";
    if ($inpCover)  $inpCover.value  = p.cover_image_url || "";
    if ($inpTw)     $inpTw.value     = p.social_twitter || "";
    if ($inpIg)     $inpIg.value     = p.social_instagram || "";
    if ($inpTt)     $inpTt.value     = p.social_twitch || "";
    if ($inpRd)     $inpRd.value     = p.social_reddit || "";
    if ($inpYt)     $inpYt.value     = p.social_youtube || "";
  }
  applyJoinedAndSocials(p, stats);
}

  // ——— Load profile data ———
async function loadProfile() {
  const current = getCurrentCustomer();
  if (!current?.id) {
    console.warn("[eg-profile] no logged-in customer; skip loadProfile()");
    return;
  }
  const url = `${API}/profiles/me?customerId=${encodeURIComponent(current.id)}&ts=${Date.now()}`;
  console.log("[eg-profile] loadProfile for", current.id, "url", url);
  console.log("[eg-profile] GET", url);

  try {
    const res = await fetch(url, { cache: "no-store" });
    if (!res.ok) throw new Error(`profile fetch failed: ${res.status}`);
    const data = await res.json();

    if (!data?.ok || !data.profile) {
      console.warn("[eg-profile] no profile in response", data);
      return;
    }

    console.log("[eg-profile] hydrating", data.profile);
    hydrateProfile(data.profile, data.stats || {}, true);
  } catch (err) {
    console.error("[eg-profile] loadProfile error", err);
  }
}

function applyJoinedAndSocials(p, stats = {}) {
  // Joined
  if ($joined) {
    const raw =
      stats.customer_created_at ||
      p.customer_created_at ||
      p.shopify_customer_created_at ||
      p.joined_at || p.created_at || p.createdAt;
    const d = parseMaybeShopifyDate(raw);
    $joined.textContent = d ? `Joined ${d.toLocaleDateString()}` : '';
  }

  // Socials (supports flattened or nested)
  if ($socials) {
    const s = (p.socials && typeof p.socials === 'object') ? p.socials : {};
    const pick = (...k) => k.map(x => p[x] ?? s[x]).find(Boolean);
    const norm = (v, base) => {
      if (!v) return '';
      if (/^https?:\/\//i.test(v)) return v;
      if (v.startsWith('@')) v = v.slice(1);
      return base ? base + v : v;
    };

    const tw = norm(pick('social_twitter','twitter','x'), 'https://twitter.com/');
    const ig = norm(pick('social_instagram','instagram'), 'https://instagram.com/');
    const tt = norm(pick('social_twitch','twitch'),       'https://twitch.tv/');
    const rd = norm(pick('social_reddit','reddit'),       'https://reddit.com/u/');
    const yt = norm(pick('social_youtube','youtube'),     'https://youtube.com/');

    const items = [
      tw && { k:'tw', url:tw, label:'Twitter/X' },
      ig && { k:'ig', url:ig, label:'Instagram' },
      tt && { k:'tt', url:tt, label:'Twitch' },
      rd && { k:'rd', url:rd, label:'Reddit' },
      yt && { k:'yt', url:yt, label:'YouTube' },
    ].filter(Boolean);

    $socials.innerHTML = items.length
      ? items.map(i => `
          <a class="egp-social" href="${i.url}" target="_blank" rel="noopener" title="${i.label}">
            <img class="egp-social__img"
                src="${SOCIAL_ICON_URLS[i.k] || SOCIAL_ICON_URLS.default}"
                alt="${i.label}" width="18" height="18" loading="lazy" decoding="async">
          </a>
        `).join('')
      : '';
    $socials.hidden = items.length === 0;
  }
}

async function loadStats() {
  const params = new URLSearchParams(location.search);
  const u = params.get("u");

  try {
    let stats;

    if (u) {
      let data;
      if (window._egPublicCid) {
        // same logic as accounts page → full stats by customerId
        const res = await fetch(`${API}/profiles/stats?customerId=${window._egPublicCid}&ts=${Date.now()}`, { cache: 'no-store' });
        data = await res.json();
      } else {
        // first paint before CID is set: fallback
        const res = await fetch(`${API}/profiles/by-name/${encodeURIComponent(u)}?ts=${Date.now()}`, { cache: 'no-store' });
        data = await res.json();
      }
      if (!data?.ok) throw new Error("Bad public stats");
      stats = data.stats;
    } else {
      // own profile (unchanged)
      const current = getCurrentCustomer();
      if (!current?.id) return;
      const res = await fetch(`${API}/profiles/stats?customerId=${current.id}&ts=${Date.now()}`, { cache: 'no-store' });
      const data = await res.json();
      if (!data?.ok) throw new Error("Bad stats");
      stats = data.stats;
    }

    // ✅ Safe DOM updates (no optional chaining on left side!)
    if (document.getElementById("statComments"))
      document.getElementById("statComments").textContent = Number(stats.comments) || 0;

    if (document.getElementById("statLikesGiven"))
      document.getElementById("statLikesGiven").textContent = Number(stats.likes_given) || 0;

    if (document.getElementById("statLikesReceived"))
      document.getElementById("statLikesReceived").textContent = Number(stats.likes_received) || 0;

    if (document.getElementById("statAchievements"))
      document.getElementById("statAchievements").textContent = Number(stats.achievements_unlocked) || 0;

    if (document.getElementById("statReviews"))
      document.getElementById("statReviews").textContent = Number(stats.reviews) || 0;

    if (document.getElementById("statDailyStreak"))
      document.getElementById("statDailyStreak").textContent = Number(stats.daily_streak) || 0;

    if (document.getElementById("statWeeklyStreak"))
      document.getElementById("statWeeklyStreak").textContent = Number(stats.weekly_streak) || 0;

    // Level + header minis (coerce)
    const lvlNum = Number(stats.level);
    if ($level && !isNaN(lvlNum)) $level.textContent = `Lvl ${lvlNum}`;

    if ($pubLevel) {
      $pubLevel.textContent = !isNaN(lvlNum) ? `Lvl ${lvlNum}` : '';
    }
    if ($pubXp) {
      const totalNum = Number(stats.total_xp);
      $pubXp.textContent = !isNaN(totalNum) ? `XP ${totalNum}` : '';
    }

    // After stats are loaded in loadStats()
    if ($joined && !$joined.textContent) {
      const raw = stats?.customer_created_at || stats?.created_at;
      const jd = parseMaybeShopifyDate(raw);
      $joined.textContent = jd ? `Joined ${jd.toLocaleDateString()}` : '';
    }

    // Level-up confetti (coerced)
    try {
      const keyId = (u || getCurrentCustomer()?.id || 'self');
      const key = `egp:lastLevel:${keyId}`;
      const prev = Number(localStorage.getItem(key) || '0');
      if (!isNaN(lvlNum) && lvlNum > prev) {
        const targetEl = $level || document.querySelector('#levelBadge') || document.querySelector('.egp-banner');
        confettiBurst(targetEl);
      }
      if (!isNaN(lvlNum)) localStorage.setItem(key, String(lvlNum));
    } catch (e) { /* non-fatal */ }

    // XP bar — prefer granular fields; fallback to derived from total_xp
    if ($xpText && $xpLevelLbl && $xpBarInner) {
      const lvl = !isNaN(lvlNum) ? lvlNum : 1;
      let inLvl = Number(stats.level_xp);
      let next  = Number(stats.next_level_xp);
      let pct   = Number(stats.progress_pct);

      if (isNaN(inLvl) || isNaN(next) || isNaN(pct)) {
        const total = Number(stats.total_xp);
        if (!isNaN(total)) {
          const prevCap = xpForLevel(lvl);
          const nextCap = xpForLevel(lvl + 1);
          inLvl = Math.max(0, total - prevCap);
          next  = Math.max(1, nextCap - prevCap);
          pct   = Math.max(0, Math.min(100, (inLvl / next) * 100));
        } else {
          inLvl = 0; next = 100; pct = 0;
        }
      }

      $xpText.textContent = `${inLvl} / ${next} XP`;
      $xpLevelLbl.textContent = `Level ${lvl + 1}`;
      $xpBarInner.style.width = `${pct}%`;
    }

    if (stats?.level != null && stats?.total_xp != null) {
      renderXpRules();
      renderRewards(stats.level, stats.total_xp);
    }

  } catch (err) {
    console.error("[eg-profile] stats error", err);
  }
}

function findListByHeading(panelId, headingSubstr, fallbackSelector) {
  const panel = document.getElementById(panelId);
  if (panel) {
    const cards = panel.querySelectorAll('.egp-card');
    for (const card of cards) {
      const h3 = card.querySelector('h3');
      if (h3 && h3.textContent.toLowerCase().includes(headingSubstr)) {
        return card.querySelector('.egp-list');
      }
    }
  }
  return document.querySelector(fallbackSelector);
}

function renderRecentComments(listEl, comments) {
  if (!listEl) return;
  let html = '';
  let lastBand = null;
  (comments || []).forEach(c => {
    const title  = c.product_title || `Product ${c.product_id}`;
    const href   = gearDbHref(c, 'comment');
    const whenD  = new Date(c.created_at);
    const when   = whenD.toLocaleDateString();
    const time   = whenD.toLocaleString();
    const text   = (c.body || '').trim();
    const img    = c.product_image_url || '';
    const variant= c.variant_title ? `<span class="egp-chip">${escapeHtml(c.variant_title)}</span>` : '';
    const verified = c.verified_purchase ? `<span class="egp-chip egp-chip--ok">Verified</span>` : '';

    const band = dateBand(whenD);
    if (band !== lastBand) {
      html += `<li class="egp-group">${band}</li>`;
      lastBand = band;
    }

    html += `
      <li class="egp-li">
        <div class="egp-item">
          ${img ? `<img class="egp-item__thumb" src="${escapeHtml(img)}" alt="">` : ''}
          <div class="egp-item__main">
            <div class="egp-item__head">
              <a class="egp-item__product" target="_blank" rel="noopener" href="${href}">${escapeHtml(title)}</a>
              <div class="egp-item__meta" title="${escapeHtml(time)}"><span>(${escapeHtml(timeAgo(whenD))})</span></div>
              ${isNewSince(whenD) ? `<span class="egp-new">NEW</span>` : ``}
              ${variant}${verified}
              </div>
             ${text ? `
               <div class="egp-item__body">
                 <div class="egp-clamp">${escapeHtml(text)}</div>
                 ${text.length > 180 ? `<button class="egp-more" data-expand aria-expanded="false">Show more</button>` : ``}
               </div>` : ``}
            
          </div>
        </div>
      </li>`;
  });
  if (!listEl) return html;
  listEl.innerHTML = html || `<li class="egp-empty">No recent comments</li>`;
}

function renderRecentReviews(listEl, reviews) {
  if (!listEl) return;
  let html = '';
  let lastBand = null;

  (reviews || []).forEach(rv => {
    const title  = rv.product_title || `Product ${rv.product_id}`;
    const href   = gearDbHref(rv, 'review');
    const whenD  = new Date(rv.updated_at || rv.created_at);
    const when   = whenD.toLocaleDateString();
    const time   = whenD.toLocaleString();
    const img    = rv.product_image_url || '';
    const text   = (rv.text || '').trim();
    const parts  = ['surface','base','performance','comfort','durability']
      .map(k => Number(rv[k] ?? 0)).filter(n => !isNaN(n));
    const avg    = parts.length ? parts.reduce((a,b)=>a+b,0)/parts.length : 0;

    const variant = rv.variant_title ? `<span class="egp-chip">${escapeHtml(rv.variant_title)}</span>` : '';
    const verified = rv.verified_purchase ? `<span class="egp-chip egp-chip--ok">Verified</span>` : '';

    const band = dateBand(whenD);
    if (band !== lastBand) {
      html += `<li class="egp-group">${band}</li>`;
      lastBand = band;
    }

    html += `
      <li class="egp-li">
        <div class="egp-item">
          ${img ? `<img class="egp-item__thumb" src="${escapeHtml(img)}" alt="">` : ''}
          <div class="egp-item__main">
            <div class="egp-item__head">
              <a class="egp-item__product" href="${href}" target="_blank" rel="noopener">
                ${escapeHtml(title)}
              </a>
              ${isNewSince(whenD) ? `<span class="egp-new">NEW</span>` : ``}
              ${variant}${verified}
              <div class="egp-item__meta" title="${escapeHtml(time)}"><span>(${escapeHtml(timeAgo(whenD))})</span></div>
            </div>
            <span>${renderStars(avg)}</span>
            ${text ? `
              <div class="egp-item__body">
                <div class="egp-clamp">${escapeHtml(text)}</div>
                ${text.length > 180 ? `<button class="egp-more" data-expand aria-expanded="false">Show more</button>` : ``}
              </div>` : ``}
            </div>
        </div>
      </li>`;
  });
  if (!listEl) return html;
  listEl.innerHTML = html || `<li class="egp-empty">No recent reviews</li>`;
}

function renderRecentReactions(listEl, reactions) {
  if (!listEl) return;
  let html = '';
  let lastBand = null;

  (reactions || []).forEach(r => {
    const href   = gearDbHref(r, 'reaction');
    const whenD  = new Date(r.created_at);
    const when   = whenD.toLocaleDateString();
    const time   = whenD.toLocaleString();
    const img    = r.product_image_url || '';
    const raw    = (r.comment_body || '').trim();
    const titleText = raw ? (raw.length > 120 ? raw.slice(0,120)+'…' : raw) : '(no comment text)';
    const chip   = r.type ? `<span class="egp-chip egp-chip--type">${escapeHtml(r.type)}</span>` : '';

    const band = dateBand(whenD);
    if (band !== lastBand) {
      html += `<li class="egp-group">${band}</li>`;
      lastBand = band;
    }

    html += `
      <li class="egp-li">
        <div class="egp-item">
          ${img ? `<img class="egp-item__thumb" src="${escapeHtml(img)}" alt="">` : ''}
          <div class="egp-item__main">
            <div class="egp-item__head">
              <a class="egp-item__product" href="${href}" target="_blank" rel="noopener">
                ${escapeHtml(titleText)}
              </a>
              ${isNewSince(whenD) ? `<span class="egp-new">NEW</span>` : ``}
              ${chip}
              <div class="egp-item__meta" title="${escapeHtml(time)}"><span>(${escapeHtml(timeAgo(whenD))})</span></div>
            </div>
           </div>
        </div>
      </li>`;
  });
  if (!listEl) return html;
  listEl.innerHTML = html || `<li class="egp-empty">No recent reactions</li>`;
}

async function loadActivity(customerId) {
  try {
    showActivitySkeletons();
    console.log('[eg-profile] loadActivity start →', customerId);
    const url = `${API_BASE}/profiles/activity?customerId=${encodeURIComponent(customerId)}`;
    const res = await fetch(url, { method: 'GET' });
    if (!res.ok) {
      console.error('[eg-profile] loadActivity failed', res.status);
      return;
    }

    const data = await res.json();
    console.log('[eg-profile] activity payload', data);

    // Store full arrays (we cap per section in the slicer)
    activityState.commentsItems  = Array.isArray(data.comments)  ? data.comments  : [];
    activityState.reviewsItems   = Array.isArray(data.reviews)   ? data.reviews   : [];
    activityState.reactionsItems = Array.isArray(data.reactions) ? data.reactions : [];

    // Reset to page 1 on fresh fetch
    activityState.commentsPage  = 1;
    activityState.reviewsPage   = 1;
    activityState.reactionsPage = 1;

    // Render current pages
    updateActivityUI();
    console.log('[eg-profile] activity rendered (paged)');

  } catch (err) {
    console.error('[eg-profile] loadActivity error', err);
  }
}

function updateActivityUI() {
  // —— locate lists (your existing helpers) ——
  const commentsList = findListByHeading('panel-activity', 'recent comments', '#panel-activity .egp-list.egp-list--divided');
  const reactionsList = document.getElementById('recentReactions')
    || findListByHeading('panel-activity', 'recent reactions', '#panel-activity .egp-list:last-of-type');
  const reviewsList = document.getElementById('recentReviews')
    || findListByHeading('panel-activity', 'recent reviews', '#panel-activity .egp-list:last-of-type');

  // COMMENTS
  if (commentsList) {
    const lim  = ACTIVITY_LIMITS.comments;
    const page = sliceForPage(activityState.commentsItems, activityState.commentsPage, lim.pageSize, lim.max);
    animateListSwap(commentsList, () => renderRecentComments(commentsList, page.data));
    const pager = ensurePagerAfter(commentsList, 'pager-comments');
    renderPager(
      pager,
      { page: page.page, pages: page.pages, total: page.total, pageSize: lim.pageSize },
      (newPage) => { activityState.commentsPage = newPage; updateActivityUI(); }
    );
  }

  // REVIEWS
  if (reviewsList) {
    const lim  = ACTIVITY_LIMITS.reviews;
    const page = sliceForPage(activityState.reviewsItems, activityState.reviewsPage, lim.pageSize, lim.max);
    animateListSwap(reviewsList, () => renderRecentReviews(reviewsList, page.data));
    const pager = ensurePagerAfter(reviewsList, 'pager-reviews');
    renderPager(
      pager,
      { page: page.page, pages: page.pages, total: page.total, pageSize: lim.pageSize },
      (newPage) => { activityState.reviewsPage = newPage; updateActivityUI(); }
    );
    decorateActivityHeadings();
  }

  // REACTIONS
  if (reactionsList) {
    const lim  = ACTIVITY_LIMITS.reactions;
    const page = sliceForPage(activityState.reactionsItems, activityState.reactionsPage, lim.pageSize, lim.max);
    animateListSwap(reactionsList, () => renderRecentReactions(reactionsList, page.data));
    const pager = ensurePagerAfter(reactionsList, 'pager-reactions');
    renderPager(
      pager,
      { page: page.page, pages: page.pages, total: page.total, pageSize: lim.pageSize },
      (newPage) => { activityState.reactionsPage = newPage; updateActivityUI(); }
    );
  }
}

async function loadAchievements() {
  const params = new URLSearchParams(location.search);
  const u = params.get("u");
  const wrap = document.getElementById("achievementsGrid");
  if (!wrap) return;

  wrap.innerHTML = '<p class="egp-muted">Loading…</p>';

  try {
    let cid;
    if (u) {
      const res = await fetch(
        `${API}/profiles/by-name/${encodeURIComponent(u)}?ts=${Date.now()}`,
        { cache: "no-store" }
      );
      const data = await res.json();
      if (!data?.ok || !data.profile?.shopify_customer_id)
        throw new Error("Bad profile lookup");
      cid = data.profile.shopify_customer_id;
    } else {
      cid = getCurrentCustomer()?.id;
    }
    if (!cid) return;

    const res = await fetch(
      `${API}/profiles/achievements?customerId=${cid}&ts=${Date.now()}`,
      { cache: "no-store" }
    );
    const data = await res.json();
    if (!data?.ok) throw new Error("Bad achievements");

    ensureAchievementsFilter();
    ensureAchvXpCSS();
    const rules = await getXpRules();

    wrap.innerHTML = "";
    if (!data.items.length) {
      wrap.innerHTML = '<p class="egp-muted">No achievements yet.</p>';
      return;
    }

    // attach XP values to each achievement
    const items = data.items.map((a) => {
      return { ...a, xp: findAchievementXp(a, rules) };
    });

    // group into bands
    const groups = { Bronze: [], Silver: [], Gold: [], Platinum: [] };
    for (const a of items) {
      const xp = a.xp || 0;
      if (xp < 100) groups.Bronze.push(a);
      else if (xp < 500) groups.Silver.push(a);
      else if (xp < 1000) groups.Gold.push(a);
      else groups.Platinum.push(a);
    }

    // fixed order
    const order = [
      "Bronze",
      "Silver",
      "Gold",
      "Platinum",
    ];

    for (const band of order) {
      const label = band.split(" ")[0]; // Bronze, Silver, Gold, Platinum
      const bandItems = groups[label];
      if (!bandItems || !bandItems.length) continue;

      const section = document.createElement("div");
      section.className = "egp-achv-section";

      const header = document.createElement("h3");
      header.className = "egp-achv-header";
      header.innerHTML = `
        <button class="egp-achv-toggle" aria-expanded="false">
          ${band} <span class="caret">▼</span>
        </button>`;
      section.appendChild(header);

      const body = document.createElement("div");
      body.className = "egp-achv-body collapsed"; // ← add collapse

      bandItems.sort((a, b) => a.xp - b.xp).forEach((a) => {
        const when = a.unlocked_at
          ? new Date(a.unlocked_at).toLocaleDateString()
          : null;
        const div = document.createElement("div");
        div.className = "egp-badge" + (a.unlocked ? "" : " egp-badge--dim");
        div.innerHTML = `
          <div class="egp-badge__icon">${a.icon || "🏅"}</div>
          <div style="display:flex;flex-direction:column;justify-content:space-between;height:100%;">
            <p class="egp-badge__title">
              ${a.title}
              ${a.xp > 0 ? `<span class="egp-xp-chip">+${a.xp} XP</span>` : ``}
            </p>
            <p class="egp-muted egp-text-sm">${a.description || ""}</p>
            ${
              a.unlocked
                ? `<small class="egp-muted">Unlocked • ${when || ""}</small>`
                : `<small class="egp-muted">Locked</small>`
            }
          </div>`;
        body.appendChild(div);
      });

      section.appendChild(body);
      wrap.appendChild(section);

      // toggle handler
      const btn = header.querySelector(".egp-achv-toggle");
      btn.addEventListener("click", () => {
        const expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!expanded));
        body.classList.toggle("collapsed", expanded);
        btn.querySelector(".caret").textContent = expanded ? "▼" : "▲";
      });
    }
  } catch (err) {
    console.error("[eg-profile] achievements error", err);
    wrap.innerHTML = "<p class='egp-muted'>Could not load achievements.</p>";
  }
}

async function loadNotifications(customerId) {
  const wrap = document.getElementById("notificationsList");
  const markBtn = document.getElementById("markAllReadBtn");
  if (!wrap) return;

  try {
    wrap.textContent = "Loading…";
    const res = await fetch(`${API}/notifications?customerId=${encodeURIComponent(customerId)}`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();

    if (!data.ok || !Array.isArray(data.items) || data.items.length === 0) {
      wrap.textContent = "No notifications yet.";
      if (markBtn) markBtn.style.display = "none"; // hide button
      return;
    }

    // render list
    wrap.innerHTML = "";
    let unreadIds = [];
    data.items.forEach(n => {
      if (!n.read) unreadIds.push(n.id);

      const li = document.createElement("div");
      li.className = `notif-item ${n.read ? "read" : "unread"}`;

      let inner = "";
      try {
        if (n.type === "reply" || n.type === "comment") {
          inner = renderRecentComments(null, [n]);
        } else if (n.type === "review") {
          inner = renderRecentReviews(null, [n]);
        } else if (n.type === "reaction") {
          inner = renderRecentReactions(null, [n]);
        }
      } catch (e) {
        console.warn("Renderer failed for notification", n, e);
      }

      // fallback if nothing rendered
      if (!inner) {
        const safeTxt = escapeHtml(n.text || n.body || "(no details)");
        inner = `<div class="notif-context">${safeTxt}</div>`;
      }

      li.innerHTML = inner;
      wrap.appendChild(li);
    });

    // toggle button visibility
    if (markBtn) {
      if (unreadIds.length === 0) {
        markBtn.style.display = "none";
      } else {
        markBtn.style.display = "inline-block";
        markBtn.onclick = async () => {
          try {
            const res = await fetch(`${API}/notifications/mark-read`, {
              method: "PUT",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ customerId, ids: unreadIds })
            });
            const out = await res.json();
            console.log("[notifications] mark-read response", out);
            loadNotifications(customerId); // refresh
          } catch (err) {
            console.error("[notifications] mark all read failed", err);
            toast("Failed to mark as read", "error");
          }
        };
      }
    }

  } catch (err) {
    console.error("[eg-profile] notifications error", err);
    wrap.textContent = "Failed to load notifications.";
    if (markBtn) markBtn.style.display = "none";
  }
}

const markBtn = document.getElementById("markAllReadBtn");
if (markBtn) {
  markBtn.onclick = async () => {
    try {
      // collect unread IDs
      const ids = data.items.filter(n => !n.read).map(n => n.id);
      if (!ids.length) return;

      const res = await fetch(`${API}/notifications/mark-read`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ customerId, ids })
      });
      const out = await res.json();
      console.log("[notifications] mark-read response", out);

      // refresh list
      loadNotifications(customerId);
    } catch (err) {
      console.error("[notifications] mark all read failed", err);
      toast("Failed to mark as read", "error");
    }
  };
}

// Detect if we’re viewing a public profile (?u=...)
const viewParams = new URLSearchParams(location.search);
const viewingUser = viewParams.get("u");

if (viewingUser) {
  fetch(`${API}/profiles/by-name/${encodeURIComponent(viewingUser)}?ts=${Date.now()}`, {
    cache: "no-store",
  })
    .then(r => r.json())
    // in the public profile branch:
    .then(({ ok, profile, stats }) => {
      if (!ok || !profile) return;

      // 1) ensure CID is set first
        if (profile.shopify_customer_id) {
          window._egPublicCid = profile.shopify_customer_id;

          // 🔧 backfill just joined + socials from the richer /me payload
          fetch(`${API}/profiles/me?customerId=${window._egPublicCid}&ts=${Date.now()}`, { cache: 'no-store' })
            .then(r => r.ok ? r.json() : null)
            .then(d => {
              if (d?.ok && d.profile) applyJoinedAndSocials(d.profile, stats || {});
            })
            .catch(() => {});
        }
      hydrateProfile(profile, stats || {}, false);

      // 2) now load full stats (will use CID below)
      loadStats();

      if (profile.shopify_customer_id) {
        loadActivity(profile.shopify_customer_id);
        loadAchievements();
      }
    })
    .catch(err => console.error("[eg-profile] public load error", err));
} else {
  console.log("[eg-profile] own account mode");
  const current = getCurrentCustomer();
  console.log("[eg-profile] current", current);

  loadProfile()
    .then(() => console.log("[eg-profile] profile loaded"))
    .catch(err => console.error('[eg-profile] load error', err));

  loadStats()
    .then(() => console.log("[eg-profile] stats loaded"))
    .catch(err => console.error('[eg-profile] stats load error', err));

  if (current?.id) {
    loadActivity(current.id)
      .then(() => console.log("[eg-profile] activity loaded"))
      .catch(err => console.error('[eg-profile] activity error', err));
      loadXpHistory(current.id, { reset: true });
  }

  loadAchievements()
    .then(() => console.log("[eg-profile] achievements loaded"))
    .catch(err => console.error('[eg-profile] achievements load error', err));
}
});
